// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { AccountWidgetEvents, AccountWidgetViewModel } from '../../ViewModels/AccountWidgetViewModel';
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import React from 'react';
import { AccountWidgetItem } from './AccountWidgetItem';
import { Button } from './Button';
import { NewAccountDetailsPanel } from '../panels/NewAccountDetailsPanel';
import { AccountWidgetDragAndDrop } from './AccountWidgetDragAndDrop';
import AdaptiveText from '@front/sharedcomponents/AdaptiveText/AdaptiveText';
import ArrowDown from '@styles/webdesktop/Icons/arrowDown.svg';
import AccountMenu from '@styles/webdesktop/Icons/accountMenu.svg';
import { InstrumentTypeLogo } from './InstrumentTypeLogo';
import { HoverableContextMenuComponent } from './HoverableContextMenuComponent';
export class AccountWidget extends WMComponent {
    constructor(props) {
        super(props, AccountWidgetViewModel);
        this.accWidgetHoverTimer = null;
        this.accWidgetInfoHoverTimer = null;
        this.openingTimerMs = 500;
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
        this.myAccountDetailsPanel = React.createRef();
        this.accountWidgetInfoRef = React.createRef();
        this.accWidgetBtnContainerRef = React.createRef();
        this.accWidgetInfoBlockContainerOver = this.accWidgetInfoBlockContainerOver.bind(this);
        this.accWidgetInfoBlockContainerLeave = this.accWidgetInfoBlockContainerLeave.bind(this);
        this.accWidgetBtnContainerOver = this.accWidgetBtnContainerOver.bind(this);
        this.accWidgetBtnContainerLeave = this.accWidgetBtnContainerLeave.bind(this);
        this.accWidgetBtnMouseDown = this.accWidgetBtnMouseDown.bind(this);
        this.subscribeOnUpdateDataEvent = this.subscribeOnUpdateDataEvent.bind(this);
        this.unsubscribeOnUpdateDataEvent = this.unsubscribeOnUpdateDataEvent.bind(this);
        this.subscribeOnUpdateRelationsEvent = this.subscribeOnUpdateRelationsEvent.bind(this);
        this.unsubscribeOnUpdateRelationsEvent = this.unsubscribeOnUpdateRelationsEvent.bind(this);
        this.subscribeOnValidateEvent = this.subscribeOnValidateEvent.bind(this);
        this.unsubscribeOnValidateEvent = this.unsubscribeOnValidateEvent.bind(this);
        this.subscribeOnUpdateRelationOfAccountDetailsEvent =
            this.subscribeOnUpdateRelationOfAccountDetailsEvent.bind(this);
        this.unsubscribeOnUpdateRelationOfAccountDetailsEvent =
            this.unsubscribeOnUpdateRelationOfAccountDetailsEvent.bind(this);
        this.subscribeOnUpdatePositionEvent = this.subscribeOnUpdatePositionEvent.bind(this);
        this.unsubscribeOnUpdatePositionEvent = this.unsubscribeOnUpdatePositionEvent.bind(this);
        this.itemDragNDropEnd = this.itemDragNDropEnd.bind(this);
    }
    componentWillUnmount() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.componentWillUnmount();
    }
    localize() {
        var _a;
        this.accBtnTooltip = Resources.getResource('accountDetailsWidget.DropdownButton.Tooltip');
        this.AccountHeader = (_a = Resources.getResource('accountDetailsWidget.DropdownButton')) === null || _a === void 0 ? void 0 : _a.toLocaleUpperCase();
    }
    subscribeOnUpdateDataEvent(callback) {
        this.viewModel.subscribeEvent(AccountWidgetEvents.UpdateWidgetItemsData, callback);
    }
    unsubscribeOnUpdateDataEvent(callback) {
        this.viewModel.unsubscribeEvent(AccountWidgetEvents.UpdateWidgetItemsData, callback);
    }
    subscribeOnUpdateRelationsEvent(callback) {
        this.viewModel.subscribeEvent(AccountWidgetEvents.UpdateWidgetItemsRelations, callback);
    }
    unsubscribeOnUpdateRelationsEvent(callback) {
        this.viewModel.unsubscribeEvent(AccountWidgetEvents.UpdateWidgetItemsRelations, callback);
    }
    subscribeOnValidateEvent(callback) {
        this.viewModel.subscribeEvent(AccountWidgetEvents.ValidateWidgetItems, callback);
    }
    unsubscribeOnValidateEvent(callback) {
        this.viewModel.unsubscribeEvent(AccountWidgetEvents.ValidateWidgetItems, callback);
    }
    subscribeOnUpdateRelationOfAccountDetailsEvent(callback) {
        this.viewModel.subscribeEvent(AccountWidgetEvents.UpdateRelationOfAccountDetailsPanel, callback);
    }
    unsubscribeOnUpdateRelationOfAccountDetailsEvent(callback) {
        this.viewModel.unsubscribeEvent(AccountWidgetEvents.UpdateRelationOfAccountDetailsPanel, callback);
    }
    subscribeOnUpdatePositionEvent(callback) {
        this.viewModel.subscribeEvent(AccountWidgetEvents.UpdateWidgetDragAndDropPosition, callback);
    }
    unsubscribeOnUpdatePositionEvent(callback) {
        this.viewModel.unsubscribeEvent(AccountWidgetEvents.UpdateWidgetDragAndDropPosition, callback);
    }
    accWidgetBtnContainerOver(event) {
        this.accWidgetHoverTimer = setTimeout(() => {
            this.viewModel.accWidgetBtnContainerOver(this.accWidgetBtnContainerRef.current);
            this.accWidgetHoverTimer = null;
        }, this.openingTimerMs);
    }
    accWidgetBtnContainerLeave(event) {
        if (!isNullOrUndefined(this.accWidgetHoverTimer)) {
            clearTimeout(this.accWidgetHoverTimer);
            this.accWidgetHoverTimer = null;
        }
        this.viewModel.accWidgetBtnContainerLeave(event);
    }
    accWidgetBtnMouseDown() {
        this.viewModel.accWidgetBtnMouseDown();
    }
    accWidgetInfoBlockContainerOver(event) {
        this.accWidgetInfoHoverTimer = setTimeout(() => {
            this.viewModel.accWidgetInfoBlockContainerOver(event, this.accountWidgetInfoRef.current, this.myAccountDetailsPanel.current);
            this.accWidgetInfoHoverTimer = null;
        }, this.openingTimerMs);
    }
    accWidgetInfoBlockContainerLeave(event) {
        if (!isNullOrUndefined(this.accWidgetInfoHoverTimer)) {
            clearTimeout(this.accWidgetInfoHoverTimer);
            this.accWidgetInfoHoverTimer = null;
        }
        this.viewModel.accWidgetInfoBlockContainerLeave(event);
    }
    itemDragNDropEnd(itemKey) {
        this.viewModel.itemDragNDropEnd(itemKey);
    }
    render() {
        const { hovered, visible, AccountModeStr, InstrumentType, accWidgetBtnSelectedClass, AccountValue, tilesTypes, DragNDropInProcess, accountId, detailsGroupItemStateSetting, clickedRowTypePointer } = this.state;
        const tiles = Array.from(tilesTypes.entries());
        return (React.createElement("div", { className: `accountWidgetDivStyle ${AccountModeStr}-opacity${hovered ? ' hoverState' : ''}`, style: { display: visible ? 'flex' : 'none' } },
            React.createElement(HoverableContextMenuComponent, { refToElement: this.accWidgetBtnContainerRef, contextMenuRef: this.state.contextMenuRef, onPointerEnter: this.accWidgetBtnContainerOver, onPointerLeave: this.accWidgetBtnContainerLeave, className: `accWidgetBtn-container ${AccountModeStr}-btn` },
                React.createElement("div", { className: "accWidgetBtn-inner" },
                    React.createElement("div", { className: "accWidgetBtn-container-left" },
                        React.createElement(Button, { buttonStyle: `accWidget-mainHeaderButtonClass accWidgetBtn ${accWidgetBtnSelectedClass}`, tooltip: this.accBtnTooltip, onClick: this.accWidgetBtnMouseDown, image: React.createElement(AccountMenu, null) }),
                        React.createElement("div", { className: `accountWidget-headerButton-${AccountModeStr}` }, AccountModeStr)),
                    React.createElement("div", { className: "accWidgetBtn-container-right" },
                        React.createElement("div", { className: "icon" },
                            React.createElement(ArrowDown, null)),
                        React.createElement(InstrumentTypeLogo, { instrumentType: InstrumentType })))),
            React.createElement("div", { className: "accountWidgetInfoBlockStyle", onMouseEnter: this.accWidgetInfoBlockContainerOver, onMouseLeave: this.accWidgetInfoBlockContainerLeave, ref: this.accountWidgetInfoRef },
                React.createElement("div", { className: "js-accWidget-AccountInfo", "data-tooltip": "AccountTooltip" },
                    React.createElement("div", { className: "js-top-AccountInfoDiv" }, this.AccountHeader),
                    React.createElement(AdaptiveText, { text: AccountValue, width: "70px", fontSizes: [14, 8], fontUnit: "px" })),
                tiles.map(([itemKey, tileTypePointer]) => (React.createElement(React.Fragment, { key: itemKey },
                    React.createElement("div", { className: "js-separator-accountWidget" }),
                    React.createElement(AccountWidgetItem, { itemKey: itemKey, tileTypePointer: tileTypePointer, DragNDropInProcess: DragNDropInProcess, subscribeOnUpdateDataEvent: this.subscribeOnUpdateDataEvent, unsubscribeOnUpdateDataEvent: this.unsubscribeOnUpdateDataEvent, subscribeOnUpdateRelationsEvent: this.subscribeOnUpdateRelationsEvent, unsubscribeOnUpdateRelationsEvent: this.unsubscribeOnUpdateRelationsEvent, subscribeOnValidateEvent: this.subscribeOnValidateEvent, unsubscribeOnValidateEvent: this.unsubscribeOnValidateEvent, onItemDragNDropEnd: this.itemDragNDropEnd }))))),
            React.createElement(NewAccountDetailsPanel, { refOnMainDiv: this.myAccountDetailsPanel, accountId: accountId, detailsGroupItemStateSetting: detailsGroupItemStateSetting, subscribeOnUpdateRelation: this.subscribeOnUpdateRelationOfAccountDetailsEvent, unsubscribeOnUpdateRelation: this.unsubscribeOnUpdateRelationOfAccountDetailsEvent }),
            DragNDropInProcess && (React.createElement(AccountWidgetDragAndDrop, { typePointer: clickedRowTypePointer, subscribeOnUpdatePosition: this.subscribeOnUpdatePositionEvent, unsubscribeOnUpdatePosition: this.unsubscribeOnUpdatePositionEvent }))));
    }
}
